<script lang="ts">
	import Concert from '$lib/profile/concert-artist.svelte';

	export let concerts;
</script>

{#each concerts as { start_datetime, url, external_id, venue, artist } (external_id)}
	<Concert
		artistId={artist.soundcloud_id}
		month={new Date(start_datetime).toLocaleString('default', { month: 'short' })}
		{url}
		day={new Date(start_datetime).getDate()}
		city={venue._cities.name}
		startTimestamp={new Date(start_datetime).getTime()}
	/>
{/each}
